<template>
  <div class="home" style="width: 100%">
    <div>
      <Header />
      <section class="main">
        <Lightbox v-show="modal" />
        <Carousel :images="highlights" />
        <Realisations :works="images" />
        <About />
        <Contact />
      </section>
      <Footer />
    </div>
  </div>
</template>

<script>
import Carousel from "../Carousel";
import Realisations from "../Realisations";
import About from "../About";
import Contact from "../Contact";
import Lightbox from "../Lightbox";
import Header from "../core/Header";
import Footer from "../core/Footer";
import EventBus from "@/bus/modal-bus";

export default {
  data() {
    return {
      modal: false,
      images: [],
      currentIndex: 1,
      imgsNumber: 0,
      interval: null,
    };
  },
  computed: {
    highlights() {
      return this.images.filter((el) => el.is_new);
    },
  },
  methods: {
    scrollMeTo(refName) {
      let element = this.$refs[refName],
        top = element.offsetTop;
      window.scrollTo(0, top);
    },
  },
  components: {
    About,
    Realisations,
    Carousel,
    Contact,
    Lightbox,
    Header,
    Footer,
  },
  created() {
    this.$axios.get("/api/projects").then((res) => {
      res.data.forEach((img) => {
        if (img.images.length) {
          img.splash = this._global.rServer + "s/real/1200/" + img.images[0].url;
          img.thumbnail = this._global.rServer + "s/real/600x350/" + img.images[0].url;
        }
      });
      this.$set(this, "images", res.data);
    });
    EventBus.$on("change_modal", (data) => {
      this.modal = data.modal;
    });
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/main";
</style>
